import HighlightedPickersModal from '../Modals/HighlightedPickersModal'

export const PICKERS_MODALS = {
  recommended_variants: HighlightedPickersModal,
}
